// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"368":"d65c7e9ec810be16","537":"ca412147d1fd90d6"}[chunkId] + ".js";
};